<template>
  <div class="train">
    <div class="banner">
      <img src="../../assets/banner.png" alt="" />
    </div>
    <div class="train_content container">
      <div class="video_type">
        <div class="train_title">
          <span class="iconfont iconleixing"></span>培训分类
        </div>
        <div class="type_list">
          <div class="type_item" v-for="item in videotypelist" :key="item.id" @click="typeclick(item.id)">
              {{ item.typeName }}
          </div>
        </div>
      </div>
      <div class="train_list">
        <el-row :gutter="10">
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-for="item in videoList" :key="item.id">
            <div class="train_item" @click="videoclick(item.id)">
              <div class="video_box">
                <img :src="baseurl + item.videoImg" alt="">
                <div class="box_shade">
                  <span class="iconfont iconkaishi"></span>
                </div>
              </div>
            </div>    
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "train",
  data () {
    return {
      dataForm: {
        page: 1,
        limit: 10,
        video_type: ''
      },
      videotypelist: [],
      videoList: [],
      baseurl: this.$baseurl
    }
  },
  mounted() {
    this.gettypeList();
    this.getvideoList()
  },
  methods: {
    gettypeList() {
      this.$http.get("/video/videotype/selectAll").then(res => {
        if (res.data.code == 0) {
          this.videotypelist = res.data.data;
        }
      });
    },
    async getvideoList() {
      let { data: { data, code }} = await this.$http.get('/video/page', { params: this.dataForm})
      if(code != 0) return 
      console.log(data.list);
      this.videoList = data.list
    },
    typeclick(i) {
      this.dataForm.video_type = i
      this.getvideoList()
    },
    videoclick(id) {
      console.log(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.train {
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .train_content {
    .video_type {
      .train_title {
        font-size: 24px;
        line-height: 2;
        .iconleixing {
          font-size: 28px;
          color: #3498db;
          margin-right: 5px;
        }
      }
      .type_list {
        .type_item {
          cursor: pointer;
          display: inline-block;
          border: 2px solid rgba($color: #3498db, $alpha: .6);
          padding: 5px 15px;
          margin: 5px;
          border-radius: 7px;
          background: rgba($color: #2980b9, $alpha: .6);
          color: #fff;
        }        
      }    
    }
     .train_list {
       padding: 20px 0;
        .train_item {
          width: 100%;
          margin-bottom: 10px;
          border-radius: 3px;
          overflow: hidden;
          cursor: pointer;
          .video_box {
            position: relative;
            width: 100%;
            height: 215px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .box_shade {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba($color: #000000, $alpha: .3);
              transition: all .3s;
              .iconkaishi {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
                font-size: 58px;
              }
              &:hover {
                transform: scale(1.5);
              }
            }
          }
        }
      }
  }
}
</style>